import { render, staticRenderFns } from "./RuleBindLogs.vue?vue&type=template&id=f5d672be"
import script from "./RuleBindLogs.vue?vue&type=script&lang=js"
export * from "./RuleBindLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports